import { FuseLoadable } from '@fuse';

export const FuncionarioConfig = {

    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/:organizacao/:empresa/funcionario',
            component: FuseLoadable({
                loader: () => import('./FuncionarioApp')
            })
        }
    ]
};
